import type { UnionTypeLibelle } from "../../../techniques"

export const TypeSalaire = [
  'Mensuel',
  'Horaire',
] as const

export type TypeSalaire = typeof TypeSalaire[number]

export const TypeSalaireLibelle: UnionTypeLibelle<TypeSalaire> = {
  Mensuel: 'Salaire brut mensuel',
  Horaire: 'Salaire brut horaire',
} as const
